import { AxiosError } from 'axios';

import { ExperimentId } from '../../common/experiments/experimentsConstants';
import { ApplicationType } from '../../common/platform/platformTypes';
import { isFeatureEnabled } from '../../common/users/utils/userPropertyUtils';
import { METHODS } from '../../common/utils/http/httpConstants';
import platformSingleton from '../platform/platformSingleton';
import { removeCurrentUserToken, getCurrentUserToken } from './authService';
import { http } from '../utils/services/http';

export type BetterAuthSessionMigrationStatus = 'idle' | 'upgrading' | 'upgraded' | 'failed';

let migrationStatus: BetterAuthSessionMigrationStatus = 'idle';

export const getBetterAuthSessionMigrationStatus = (): BetterAuthSessionMigrationStatus => migrationStatus;

export const resetBetterAuthSessionMigrationStatus = (): void => {
    migrationStatus = 'idle';
};

export const shouldUpgradeLegacySessionToBetterAuth = (user: object | null | undefined): boolean => {
    if (!user) return false;
    if (platformSingleton.appType !== ApplicationType.web) return false;
    if (!getCurrentUserToken()) return false;
    if (!isFeatureEnabled(ExperimentId.betterAuth, user)) return false;

    return migrationStatus === 'idle';
};

const verifyBetterAuthSession = async (): Promise<void> => {
    await http({
        url: 'users/me',
        withCredentials: true,
        skipAuthHeader: true,
        retry: 0,
    });
};

export const upgradeLegacySessionToBetterAuthIfFlagged = async (user: object | null | undefined): Promise<boolean> => {
    if (!shouldUpgradeLegacySessionToBetterAuth(user)) return false;

    migrationStatus = 'upgrading';

    try {
        await http({
            method: METHODS.POST,
            url: 'auth/upgrade-better-auth-session',
            withCredentials: true,
        });

        await verifyBetterAuthSession();
        removeCurrentUserToken();

        migrationStatus = 'upgraded';
        return true;
    } catch (error) {
        migrationStatus = 'failed';
        throw error as AxiosError;
    }
};
